import { firebase, disconnectDb } from 'app-modules/application/utils/firebase';
import { SETUP } from './types';
import { triviaLoadScoreActionThunk as loadScore } from './loadScore';

const setupConnectionState = (deviceID) => {
  if (deviceID) {
    const db = firebase.database();
    db.goOnline();
    const onlineStatusRef = db.ref(`/devices/${deviceID}/online`);
    const connectedRef = db.ref('.info/connected');
    connectedRef.on('value', (snap) => {
      const online = snap.val();

      if (online === true) {
        onlineStatusRef.set(true);
        onlineStatusRef.onDisconnect().set(false);
      } else {
        onlineStatusRef.set(false);
      }
    });

    if (window) {
      window.onunload = () => {
        onlineStatusRef.set(false);
      };
    }
  }
};

export const triviaSetupActionThunk = () => async (dispatch, getState) => {
  try {
    const { trivia } = getState();

    if (trivia.isConfigured !== true) {
      // setupConnectionState(device.ID);

      await dispatch(loadScore());

      await dispatch({ type: SETUP });
    }
  } catch (err) {
    await dispatch({ type: SETUP, payload: err, error: true });
  } finally {
    disconnectDb();
  }
};
